module.exports = __webpack_public_path__ + "img/elvenett.508e1e31.jpg";